import { useQuery } from '@tanstack/react-query';
import { getData } from '../../../../../../../utils/functional/fp';
import { useAPIErrorHandler } from '../../../../../../../components/hooks/useAPIErrorHandler';
import { getClassDescriptions, getClassDescriptionsWithVersion } from '../api';
import type { ProductType } from '../../../../../../../types';

type Params = {
  industryCode: string | number | undefined;
  productType: ProductType;
  effectiveDate?: string | null;
  productVersion?: number | null;
  state?: string | null;
};

const useGetClassDescriptions = ({
  productType,
  industryCode,
  effectiveDate,
  productVersion,
  state,
}: Params) => {
  const handleAPIError = useAPIErrorHandler();
  return useQuery({
    queryKey: [
      'class-descriptions',
      { productType, industryCode, effectiveDate, productVersion, state },
    ],
    queryFn: () =>
      productVersion != null
        ? getClassDescriptionsWithVersion(
            productType,
            industryCode as string,
            productVersion,
            { params: state ? { state } : {} }
          ).then(getData)
        : getClassDescriptions(productType, industryCode as string, {
            params: {
              ...(effectiveDate ? { effectiveDate } : {}),
              ...(state ? { state } : {}),
            },
          }).then(getData),
    onError: handleAPIError('Unable to get class descriptions'),
    enabled: Boolean(industryCode) && Boolean(productType),
  });
};

export default useGetClassDescriptions;
